import { createContext } from "react";
import React, { useEffect, useState } from 'react';

export const DarkModeContext = createContext ()

export const DarkModeContextProvider = ({ children }) => {
    const [darkMode, setDarkMode] = useState(
      JSON.parse(localStorage.getItem("darkMode")) || true
    );
  
    const toggle = () => {
      setDarkMode(!darkMode);
    };
  
    useEffect(() => {
      localStorage.setItem("darkMode", darkMode);
    }, [darkMode]);
  
    return (
      <DarkModeContext.Provider value={{ darkMode, toggle }}>
        {children}
      </DarkModeContext.Provider>
    );
  };